import resolveUrl from './utils/resolve-url';
class ResponseError extends Error {
    constructor(message, response) {
        super(message);
        Object.setPrototypeOf(this, ResponseError.prototype);
        this.response = response;
    }
}
/**
 * @param {HttpResponse<T>} response
 * @throws {ResponseError} if response code is not ok
 */
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new ResponseError(response.statusText, response);
    throw error;
}
/**
 * @param {string} url
 * @param {HttpDataFetcher} fetcher
 * @param {Object} params
 */
export function fetchData(url, fetcher, params = {}) {
    return fetcher(resolveUrl(url, params))
        .then(checkStatus)
        .then((response) => {
        // axios auto-parses JSON responses, don't need to JSON.parse
        return response.data;
    });
}
